import { Injectable } from '@angular/core';
import { AutoCompleteService } from 'ionic4-auto-complete';
import { Observable, of } from 'rxjs';
import { Advert } from '../models/advert';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdvertAutoCompleteService implements AutoCompleteService {

  advertsApiUrl = 'https://search.jobinrwanda.com/api/jobtitles';
  private adverts: Advert[] = [];

  constructor(private http: HttpClient) { }

  getResults(keyword: string): Observable<string[]> {
    let adverts$: Observable<any>;

    if (this.adverts.length === 0) {
      adverts$ = this.http.get<Advert[]>(`${this.advertsApiUrl}`);
    } else {
      adverts$ = of(this.adverts);
    }

    return adverts$.pipe(
      map((result: Advert[]) => {
        this.adverts = result;
        return result.map(item => 'Ref:' + (parseInt(item.id, 0) - 10000).toString() + ' - ' + item.title);
      }),
      map(result => {
          return keyword ? result.filter((item) => {
              return item ? item.toLowerCase().includes(keyword.toLowerCase()) : false;
            }
          ) : [];
        }
      )
    );
  }
}
